// @flow
import styled, { type StyledComponent } from 'styled-components'

const Error: StyledComponent<Object, any, any> = styled.div`
  color: red;
  padding: 6px 0;
  font-size: 12px;
`

export default Error
